import React from "react";
import { Outlet, useLocation, useNavigate, Link } from "react-router-dom";
import { Home, ShoppingBag, Heart, User as UserIcon, Camera, Bell, ChevronLeft } from "lucide-react";

const TABS = [
  { to: "/app", icon: Home, label: "Home" },
  { to: "/app/shop", icon: ShoppingBag, label: "Shop" },
  { to: "/app/try-on", icon: Camera, label: "Try-On" },
  { to: "/app/wishlist", icon: Heart, label: "Saved" },
  { to: "/app/profile", icon: UserIcon, label: "Profile" },
];

export default function AppShell() {
  const location = useLocation();
  const navigate = useNavigate();
  const isHome = location.pathname === "/app";

  return (
    <div className="min-h-screen bg-[#161616] text-white overflow-hidden grain relative">
      <div className="hidden lg:flex justify-center items-center min-h-screen py-10 px-6 bg-gradient-to-b from-[#1a1a1a] via-[#0c0c0c] to-[#1a1a1a] relative">
        <div className="absolute left-10 top-10 max-w-sm">
          <Link to="/" data-testid="app-back-to-site" className="inline-flex items-center gap-2 text-[11px] tracking-luxury uppercase text-poche-gold mb-6">
            <ChevronLeft size={14} /> Back to website
          </Link>
          <p className="text-[11px] tracking-luxury uppercase text-poche-gold">Joseph Poche</p>
          <h1 className="font-serif text-5xl mt-3 leading-tight">The POCHE App.</h1>
          <p className="text-white/55 mt-4">Virtual try-on. VIP drops. Authenticity scan. Concierge in your pocket. A live preview, running inside the experience.</p>
          <ul className="mt-8 space-y-2 text-sm text-white/65">
            <li>· iOS + Android · Native experience</li>
            <li>· Fit profile · Face shape AI</li>
            <li>· Loyalty points · VIP drops</li>
            <li>· Concierge chat · Authenticity QR</li>
          </ul>
          <div className="mt-10 grid grid-cols-2 gap-3">
            <Link to="/app" className="border border-poche-gold/40 px-4 py-3 text-[10px] tracking-luxury uppercase text-white hover:bg-poche-gold/10">iOS App Store</Link>
            <Link to="/app" className="border border-poche-gold/40 px-4 py-3 text-[10px] tracking-luxury uppercase text-white hover:bg-poche-gold/10">Google Play</Link>
          </div>
        </div>

        <div className="iphone-frame w-[380px] h-[800px] relative">
          <div className="iphone-notch" />
          <div className="absolute inset-0 overflow-y-auto bg-poche-black no-scrollbar" data-testid="app-viewport">
            {!isHome && (
              <button onClick={() => navigate(-1)} className="absolute top-12 left-4 z-30 text-white/75 hover:text-poche-gold p-2" aria-label="Back">
                <ChevronLeft size={20} />
              </button>
            )}
            <Outlet />
            <div className="h-24" />
          </div>
          <BottomNav />
        </div>
      </div>

      {/* Mobile: fullscreen */}
      <div className="lg:hidden min-h-screen flex flex-col bg-poche-black">
        {!isHome && (
          <button onClick={() => navigate(-1)} className="fixed top-3 left-3 z-30 text-white/75 hover:text-poche-gold p-2 bg-black/60 rounded-full" aria-label="Back">
            <ChevronLeft size={20} />
          </button>
        )}
        <div className="flex-1 overflow-y-auto pb-24">
          <Outlet />
        </div>
        <BottomNavMobile />
      </div>
    </div>
  );
}

function BottomNav() {
  const location = useLocation();
  return (
    <div className="absolute bottom-0 left-0 right-0 bg-poche-black/95 backdrop-blur-md border-t border-white/10 px-2 py-3 z-20">
      <div className="flex items-center justify-between px-3">
        {TABS.map((t) => {
          const active = location.pathname === t.to;
          return (
            <Link
              key={t.to}
              to={t.to}
              data-testid={`app-nav-${t.label.toLowerCase()}`}
              className="flex-1 flex flex-col items-center gap-1 py-1 transition-colors"
            >
              <t.icon size={20} strokeWidth={1.4} className={active ? "text-poche-gold" : "text-white/65"} />
              <span className={`text-[10px] tracking-luxury uppercase ${active ? "text-poche-gold" : "text-white/65"}`}>{t.label}</span>
              {active && <div className="nav-dot" />}
            </Link>
          );
        })}
      </div>
    </div>
  );
}
function BottomNavMobile() {
  const location = useLocation();
  return (
    <div className="fixed bottom-0 left-0 right-0 bg-poche-black/95 backdrop-blur-md border-t border-white/10 px-2 py-3 z-20">
      <div className="flex items-center justify-between px-3">
        {TABS.map((t) => {
          const active = location.pathname === t.to;
          return (
            <Link
              key={t.to}
              to={t.to}
              className="flex-1 flex flex-col items-center gap-1 py-1"
            >
              <t.icon size={20} strokeWidth={1.4} className={active ? "text-poche-gold" : "text-white/65"} />
              <span className={`text-[10px] tracking-luxury uppercase ${active ? "text-poche-gold" : "text-white/65"}`}>{t.label}</span>
            </Link>
          );
        })}
      </div>
    </div>
  );
}
